import { Badge } from "rsuite";
import "./BadgeColumn.css";

const SCBadgeColumn = ({ content, color }) => {
  var badgeColor = "";
  if (color) {
    badgeColor = content.toLowerCase() === "active" ? color : "#ebeef0";
  } else {
    badgeColor = content.toLowerCase() === "active" ? "#abfff8" : "#ebeef0";
  }

  return (
    <>
      <Badge
        className={"sc-badge"}
        style={{ backgroundColor: badgeColor }}
        content={content}
      />
    </>
  );
};

export default SCBadgeColumn;
